import React from 'react';
import { Link } from 'react-router-dom';
import './ISO37001.css';

const ISO37001 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">Fight Against Corruption with ISO 37001 Corruption Management System</h1>
            <h2 className="page-subtitle">Secure Your Company Reputation Against Corruption with ISO 37001</h2>
            <div className="page-text-content">
              <p>
                We're excited to introduce you to the ISO 37001 Anti-Bribery Management System, which 
                offers an effective solution to combating corruption in the business world. In this article, 
                we'll dive into what ISO 37001 is, the advantages it brings to businesses, and how it is 
                implemented in detail.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 37001?</h2>
            <div className="page-text-content">
              <p>
                ISO 37001 is an international standard designed to prevent corruption and create an 
                effective anti-corruption strategy. It helps businesses reduce the risk of corruption and 
                establish a work culture that aligns with ethical values. The standard aims to help 
                organizations define, implement, and continuously review their anti-corruption policies.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">The Basic Elements of ISO 37001</h2>
            <div className="elements-list">
              <div className="element-item">
                <h3 className="element-title">1. Corruption Risk Assessment</h3>
                <p className="element-description">
                  ISO 37001 enables organizations to identify corruption risks and effectively manage them.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">2. Policies and Procedures</h3>
                <p className="element-description">
                  Organizations establish anti-corruption policies and ensure the effective implementation 
                  of these policies.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">3. Training and Awareness</h3>
                <p className="element-description">
                  Personnel are trained on combating corruption and awareness is raised within the 
                  organization.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">4. Internal and External Audits</h3>
                <p className="element-description">
                  ISO 37001 requires organizations to regularly audit and improve their anti-corruption 
                  processes.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Advantages of ISO 37001 for Businesses:</h2>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">1. Reliable Business Image</h3>
                <p className="advantage-description">
                  ISO 37001 certification shows customers and stakeholders a strong commitment to fighting 
                  corruption.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">2. Legal Compliance</h3>
                <p className="advantage-description">
                  ISO 37001 encourages organizations to comply with national and international laws in 
                  combating corruption.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">3. Effective Risk Management</h3>
                <p className="advantage-description">
                  Organizations prevent financial losses and reputation damage by effectively managing 
                  corruption risks.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">4. Sustainable Success</h3>
                <p className="advantage-description">
                  ISO 37001 allows for the development of a sustainable anti-corruption strategy for 
                  long-term success.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How to Implement ISO 37001?</h2>
            <div className="page-text-content">
              <p>
                The implementation process of ISO 37001 can vary depending on the size and complexity of the 
                organization. However, generally, the implementation steps can be summarized as follows:
              </p>
            </div>
            <div className="steps-list">
              <div className="step-item">
                <h3 className="step-title">1. Corruption Risk Assessment</h3>
                <p className="step-description">
                  The organization identifies potential corruption risks and takes measures against these risks.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">2. Policy and Procedure Development</h3>
                <p className="step-description">
                  Anti-corruption policies and procedures in compliance with ISO 37001 standards are 
                  established.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">3. Personnel Training</h3>
                <p className="step-description">
                  Business personnel are trained on anti-corruption policies and procedures.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">4. Internal and External Audits</h3>
                <p className="step-description">
                  Anti-corruption processes are regularly subjected to internal and external audits.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">5. Continuous Improvement</h3>
                <p className="step-description">
                  Compliance with ISO 37001 standards is regularly reviewed, and action plans are created 
                  for continuous improvement.
                </p>
              </div>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO37001;

